import style from './UploadModal.module.css';
import { useState, useRef } from 'react';

const Upload = ({
  files,
  addFile,
  removeFile, // NEW: added removeFile prop
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const selectedFile = e.dataTransfer.files[0];
    if (selectedFile) processFile(selectedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) processFile(selectedFile);
  };

  const processFile = (selectedFile) => {
    // Enforce 1 file limit: remove all existing files before adding the new one
    files.forEach(f => removeFile(f.id));

    const fileInfo = {
      id: `${selectedFile.name}-${selectedFile.lastModified}`,
      name: selectedFile.name,
      size: (selectedFile.size / 1024 / 1024).toFixed(2), // MB
      type: selectedFile.type,
      lastModified: selectedFile.lastModified,
      file: selectedFile,
    };
    addFile(fileInfo);
  };

  return (
    <div className={style.openUploadContainer}>
      <h2 className={style.openTitle}>
        {files.length > 0 ? 'File Selected' : 'Upload your Documents'}
      </h2>
      
      {files.length === 0 ? (
        <div
          className={`${style.dropZone} ${isDragOver ? style.dragOver : ''}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onClick={() => fileInputRef.current?.click()}
        >
          <div className={style.uploadIcon}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <p className={style.dropTitle}>Drag & drop your resume here</p>
          <p className={style.subtext}>or click to browse files (PDF, DOC, DOCX)</p>
          
          <input
            type="file"
            ref={fileInputRef}
            className={style.hiddenInput}
            onChange={handleFileChange}
            accept=".pdf,.doc,.docx"
          />
        </div>
      ) : (
        <div className={style.fileList}>
          {files.map((file, index) => (
            <div key={file.id || index} className={style.fileItemHero}>
              <div className={style.fileInfoHero}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#432c5b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <div className={style.fileDetailsHero}>
                  <span className={style.fileNameHero}>{file.name}</span>
                  <span className={style.fileSizeHero}>{file.size} MB</span>
                </div>
              </div>
              <button 
                type="button" 
                className={style.removeBtnHero}
                onClick={(e) => {
                  e.stopPropagation();
                  removeFile(file.id);
                }}
              >
                Change File
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Upload;
